
export const colorCode = (colorName) => {
  let colorCode = ""
  switch(colorName) {
    case "パステルグリーン":
      colorCode = "#6CCC86"
      break
    case "ピンク":
      colorCode = "#F17E7A"
      break
    case "ダークブルー":
      colorCode = "#4D5C99"
      break
    case "イエロー":
      colorCode = "#F7D36F"
      break
    case "パープル":
      colorCode = "#994D80"
      break
    case "スカイブルー":
      colorCode = "#6F99F7"
      break
    case "オレンジ":
      colorCode = "#FA9C1D"
      break
    case "ライトブラウン":
      colorCode = "#B88A55"
      break
    case "ダークブラウン":
      colorCode = "#5E4027"
      break
    case "モスグリーン":
      colorCode = "#435C24"
      break
    case "ホワイトブルー":
      colorCode = "#81CEC6"
      break
    case "パステルパープル":
      colorCode = "#7679DE"
      break
    case "アップルグリーン":
      colorCode = "#60AD56"
      break
    case "ペイルオレンジ":
      colorCode = "#F79E6F"
      break
    default:
      colorCode = ""
  }

  return colorCode
}

